
import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import LoadingContainer from '../../controls/LoadingContainer'
import { useToast } from '../../controls/Toast/ToastService'
import { CiLocationArrow1 } from "react-icons/ci";
import Empty from '../../controls/Empty'
import Card from '../../controls/Card'
import { MdErrorOutline } from 'react-icons/md'
import * as opdCentersCrud from '../../../configurations/crud/opdCentersCrud'
import Paging from '../../controls/Paging'
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR, PAGE_SIZE } from '../../../configurations/initUrls';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import { EBoolBg, GetEBoolName } from '../../../configurations/enums/EBool';
import StatusContainer from '../../controls/StatusContainer';
import { EApplicationUserStatusBg, GetEApplicationUserStatusName } from '../../../configurations/enums/EApplicationUserStatus';
import { BsArrowRightSquareFill } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Input from '../../controls/Input';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { IoMdOpen } from 'react-icons/io';
import { EOPDCenterStatusBg, GetEOPDCenterStatusName } from '../../../configurations/enums/EOPDCenterStatus';
import { EDoctorStatusBg, GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus';
import Dp from '../users/Dp';
import useGlobalLoader from '../../../configurations/useGlobalLoader';


const initValues = {
  PageNo: 1,
  PageSize: 10,
  SearchTerm: "",
}
export default function CenterAll() {
  const { start, end } = useGlobalLoader()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [userData, setUserData] = useState([]);
  const [search, setSearch] = useState(initValues);
  const [LastPage, setLastPage] = useState(1);
  const [pagingData, setPagingData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDebounce, setSearchDebounce] = useDebounce("", 700);

  useEffect(() => {
    setSearchDebounce(searchTerm)
  }, [searchTerm])

  useEffect(() => {
    onSearch()
  }, [searchDebounce])


  const OnPageChange = (e) => {
    const { value } = e.target;
    setSearch({ ...search, PageNo: value })
    onSearchNew({
      PageNo: value,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm
    })
  }
  const onSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }
  const onSearch = () => {
    onSearchNew({
      PageNo: 1,
      PageSize: search.PageSize,
      SearchTerm: searchTerm
    })
  }
  const onSearchNew = (search) => {
    GetSearchUser(search)
  }

  const doRefresh = () => {
    setSearch({ ...search, PageNo: 1 })
    onSearchNew({
      PageNo: 1,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm
    })
  }

  const GetSearchUser = (params) => {
    setLoding(true)
    start()
    opdCentersCrud.GetAll(params).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setUserData(mdata.data)
        setPagingData(mdata.paging)
        setLastPage(mdata.paging.pageCount)
      } else {
        setPagingData()
        setLastPage(1)
        setUserData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setPagingData()
      setLastPage(1)
      setUserData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  return (
    <div className='flex flex-col '>
      <div className='py-3'>
        <Input Icon={<FontAwesomeIcon color='gray' icon={faSearch} />}
          onChange={onSearchChange}
          placeholder="Search Doctors"></Input>
      </div>
      <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData} >
        <div class="relative overflow-x-auto">
          {
            !loding ?
              userData.length > 0 ?
                <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                  <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                    <tr>
                      <th scope="col" class="px-6 py-3">
                        <div class="flex items-center">
                          <input id="checkbox-all" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500  focus:ring-2 " />
                          <label for="checkbox-all" class="sr-only">checkbox</label>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        #

                      </th>
                      <th scope="col" class="px-6 py-3">
                        Center Name
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Address
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Phone
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Used Balance
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Doctor's Status
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Status
                      </th>

                      <th scope="col" class="px-6 py-3">
                        Photo
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData.map((item, index) =>
                      <tr class="bg-white border-b  hover:bg-gray-100">
                        <td class="w-4 px-6 py-2">
                          <div class="flex items-center">
                            <input id="checkbox-table-search-1" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500  focus:ring-2 " />
                            <label for="checkbox-table-search-1" class="sr-only">checkbox</label>
                          </div>
                        </td>
                        <td class="px-6 py-2">
                          {item.id}
                        </td>
                        <td class="px-6 py-2">
                          {item.centerName}
                        </td>
                        <td class="px-6 py-2">
                          {item.address}, {item.city.name}, {item.city.state.name}
                        </td>
                        <td class="px-6 py-2">
                          {item.phone}
                        </td>
                        <td class="px-6 py-2">
                          {item.opdUsedBalance}
                        </td>
                        <td class="px-6 py-2">
                          <StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} />
                        </td>
                        <td class="px-6 py-2">
                          <StatusContainer bg={EOPDCenterStatusBg(item.status)} text={GetEOPDCenterStatusName(item.status)} />
                        </td>
                        <td class="px-6 py-2">
                          <Dp user={item.user} height={"h-9"} width={"w-9"} />
                        </td>
                        <td class="flex items-center px-6 py-2 sm:w-20">
                          <Link to={"/opdcenters/" + item.id + "/view"} class="cursor-pointer text-2xl  text-brand-500 hover:underline mr-1 p-1 hover:bg-gray-200 hover:rounded-lg" title='Enable'><IoMdOpen /></Link>
                        </td>
                      </tr>
                    )}

                  </tbody>
                </table>
                : <Empty>
                  No Items Found.
                </Empty>
              : <LoadingContainer />
          }
        </div>
      </Paging>
    </div>
  )
}
